// extracted by mini-css-extract-plugin
export default {"container":"DoctorRefinements_container__PFYpU","aside":"DoctorRefinements_aside__Yd3vK","title":"DoctorRefinements_title__3pbE3"};